// @ts-nocheck

import { badges } from '../assets/spine/services/win-modal';
import { cancel } from '../assets/spine/services/win-modal/backgrounds';
import { getLang } from '../i18n/l10n';
import { SpineAnimationIds, WinModalSpineAnimationIds } from '../types/animations';
import { Locales } from '../types/common';
import { BetslipNotableCases } from '../types/history';
import { WinModalAnimations } from '../types/winModal';

const { cotekiller } = badges;

const { CANCELLED, WIN, MAN_OF_MYMATCH, MORTAL_COMBO, COTE_KILLER } = WinModalAnimations;

export const getAssetsPerAnimationTypes = (animationType) => {
  switch (animationType) {
    case COTE_KILLER:
      return {
        badge: cotekiller,
        bannerAnimationId: SpineAnimationIds.BS_WIN,
        backgroundAnimationId: SpineAnimationIds.WM_LION,
      };
    case MORTAL_COMBO:
      return { bannerAnimationId: SpineAnimationIds.BS_WIN, backgroundAnimationId: SpineAnimationIds.WM_CROCO };
    case MAN_OF_MYMATCH:
      return { bannerAnimationId: SpineAnimationIds.BS_WIN, backgroundAnimationId: SpineAnimationIds.WM_SUPERMAN };
    case WIN: {
      const backgroundAnimationIds = Object.keys(WinModalSpineAnimationIds).map(
        (key) => WinModalSpineAnimationIds[key],
      );
      const nextBackgroundAnimationId =
        backgroundAnimationIds[Math.floor(Math.random() * backgroundAnimationIds.length)];
      return { bannerAnimationId: SpineAnimationIds.BS_WIN, backgroundAnimationId: nextBackgroundAnimationId };
    }
    case CANCELLED:
      return { bannerAnimationId: SpineAnimationIds.BS_CANCEL, backgroundAnimationId: null, fallback: cancel };
    default:
      return undefined;
  }
};

export const getAnimationsPerNotableCase = (notableCase) => {
  const winAssets = getAssetsPerAnimationTypes(WIN);
  const coteKillerAssets = getAssetsPerAnimationTypes(COTE_KILLER);
  const mortalComboAssets = getAssetsPerAnimationTypes(MORTAL_COMBO);
  const manOfMyMatchAssets = getAssetsPerAnimationTypes(MAN_OF_MYMATCH);
  const cancelledAssets = getAssetsPerAnimationTypes(CANCELLED);

  switch (getLang()) {
    case Locales.FR:
      return {
        [BetslipNotableCases.SINGLE_WINNING_LOW]: winAssets,
        [BetslipNotableCases.SINGLE_WINNING_MIDDLE]: winAssets,
        [BetslipNotableCases.COTE_KILLER]: coteKillerAssets,
        [BetslipNotableCases.COMBO_WINNING_LOW]: winAssets,
        [BetslipNotableCases.COMBO_WINNING_MIDDLE]: winAssets,
        [BetslipNotableCases.MORTAL_COMBO]: mortalComboAssets,
        [BetslipNotableCases.SYSTEM_WINNING]: winAssets,
        [BetslipNotableCases.MYMATCH_LOW]: winAssets,
        [BetslipNotableCases.MAN_OF_MYMATCH]: manOfMyMatchAssets,
        [BetslipNotableCases.CANCELLED]: cancelledAssets,
      }[notableCase];
    case Locales.EN:
    case Locales.DE:
    case Locales.ES:
    case Locales.IT:
    case Locales.PT:
      return {
        [BetslipNotableCases.SINGLE_WINNING_LOW]: winAssets,
        [BetslipNotableCases.SINGLE_WINNING_MIDDLE]: winAssets,
        [BetslipNotableCases.COTE_KILLER]: winAssets,
        [BetslipNotableCases.COMBO_WINNING_LOW]: winAssets,
        [BetslipNotableCases.COMBO_WINNING_MIDDLE]: winAssets,
        [BetslipNotableCases.MORTAL_COMBO]: winAssets,
        [BetslipNotableCases.SYSTEM_WINNING]: winAssets,
        [BetslipNotableCases.MYMATCH_LOW]: winAssets,
        [BetslipNotableCases.MAN_OF_MYMATCH]: manOfMyMatchAssets,
        [BetslipNotableCases.CANCELLED]: cancelledAssets,
      }[notableCase];
    default:
      return null;
  }
};
